import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from  '@angular/forms';
import { Routes, RouterModule, Router } from '@angular/router';
import { ToastService } from 'ng-uikit-pro-standard';
import { UserService } from 'src/app/services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { ThemeService } from 'src/app/services/theme.service'
import { AppConfigService } from 'src/app/app-config.service.service';

@Component({
  selector: 'app-login-recover-passwd-cs',
  templateUrl: './login-recover-passwd-cs.component.html',
  styleUrls: ['./login-recover-passwd-cs.component.scss']
})
export class LoginRecoverPasswdCSComponent implements OnInit {
  cardForm: FormGroup;
  ecomerceconcode: string

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private toast: ToastService,
    private userService: UserService,
    private translate:TranslateService, 
    public ThemeService: ThemeService, 
    private appConfigService: AppConfigService) {
    this.cardForm = fb.group({
      // materialFormCardNameEx: ['', Validators.required],
      email: ['', [Validators.email, Validators.required]],
      // materialFormCardConfirmEx: ['', Validators.required],
      // materialFormCardPasswordEx: ['', Validators.required]
    });
  }
  ngOnInit() {
    this.ThemeService.setNavaBar('navbar-disabled')
    this.ecomerceconcode = this.appConfigService.ecomerceconcode;

  }

  
  resetPass() {
    let value = this.cardForm.value;
    console.log(this.cardForm.value);
    
    this.userService.recoverPassword(value.email, this.ecomerceconcode).subscribe(result => {
      console.log(result);
      if (result.response == 1) {
        this.toast.success(this.translate.instant('msgRecPassSucc'));
        this.router.navigateByUrl('/login');
      } else {
        this.toast.error('An error has ocurred or Email is not valid');
      }
    })
  }

}
